import React from 'react';
import { Icon } from '@iconify/react';

export default function Header({ logoUrl, colorVariant }) {
  // Conversion tracking function for Google Ads
  const gtag_report_conversion = (url) => {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16814718639/GuxcCMinrvwZEK_98NE-', // Conversion ID and Label
      'value': 1.0, // Conversion value
      'currency': 'TRY', // Currency
      'event_callback': callback
    });
    return false;
  };

  // Button click handler for Discord
  const handleJoinDiscordClick = () => {
    gtag_report_conversion(); // Trigger Google Ads conversion event
    window.location.href = 'https://discord.com/invite/ZdEG29K9gZ'; // Redirect to Discord
  };

  return (
    <header
      className={`cs_site_header cs_style_1 cs_sticky_header ${colorVariant || 'cs_primary_color'}`}
      style={{ padding: '10px 0' }}
    >
      <div className="cs_main_header">
        <div className="container">
          <div className="cs_main_header_in">
            <div className="cs_main_header_left">
              <a className="cs_site_branding" href="/">
                <img
                  src={logoUrl}
                  alt="Logo"
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </a>
            </div>
            <div
              className="cs_main_header_center"
              style={{
                flex: 1,
                textAlign: 'center',
              }}
            ></div>
            <div className="cs_main_header_right">
              <button
                className="contact_button"
                onClick={handleJoinDiscordClick}
                style={buttonStyles}
                aria-label="Join Us"
              >
                <Icon
                  icon="mdi:discord"
                  style={{ width: '24px', height: '24px', marginRight: '8px' }}
                />
                <span style={buttonTextStyles}>Join Us</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

// Button styles with hover effect
const buttonStyles = {
  background: 'linear-gradient(90deg, #007BFF, #0056D2)', // Blue gradient
  color: '#fff',
  border: 'none',
  padding: '12px 24px',
  cursor: 'pointer',
  borderRadius: '50px',
  fontSize: '18px',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.2s, box-shadow 0.2s',
};

const buttonTextStyles = {
  textTransform: 'uppercase',
  letterSpacing: '1px',
};

// Add hover effect to button
buttonStyles[":hover"] = {
  transform: 'scale(1.05)',
  boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
  background: 'linear-gradient(90deg, #0056D2, #003F91)', // Darker blue on hover
};
